import type { TableAction } from './actions';
import Store from './Store';
const {
  useDispatch: useDispatch_
} = Store;
export default function useDispatch() {
  return useDispatch_() as (action: TableAction<T>) => void;
}